import template from './multi-select-dropdown.html';

class MultiSelectDropdownController {
  constructor() {
    this.filteredOptions = [];
    this.showDropdown = false;
    this.searchInput = {};
    this.filteredOptions = [];
    this.isAllSelected = true;
  }

  $onChanges() {
    this.inputName = this.dropdownPrompt || '';
    this.filteredOptions = this.options || [];
  }

  toggleDropdown($event) {
    this.showDropdown = !this.showDropdown;
    $event.preventDefault();
    $event.stopPropagation();
  }

  allSelectedChanged() {
    const type = this.isAllSelected
      ? tableau.FilterUpdateType.ADD
      : tableau.FilterUpdateType.REMOVE;

    const optionsChanged = this.options
      .filter((option) => option.selected !== this.isAllSelected)
      .map((option) => option.text);

    if (optionsChanged.length > 0) {
      this.options = this.options.map((option) => {
        option.selected = this.isAllSelected;
        return option;
      });
      this.filteredOptions = this.filteredOptions.map((filterOpt) => {
        filterOpt.selected = this.isAllSelected;
        return filterOpt;
      });

      this.updateSelection({
        filterObject: {
          name: this.dropdownName,
          values: [...optionsChanged],
          type: type,
        },
      });
    }
  }

  selectionChanged(option) {
    const type = option.selected ? tableau.FilterUpdateType.ADD : tableau.FilterUpdateType.REMOVE;

    this.options = this.options.map((opt) => {
      if (opt.text === option.text) opt.selected = option.selected;
      return opt;
    });

    // Check if everything is selected

    const numberOfSelected = this.options.reduce((accumulator, currentVal) => {
      if (currentVal.selected) accumulator++;
      return accumulator;
    }, 0);

    const isAllOptionsSelected = numberOfSelected === this.options.length;

    this.isAllSelected = isAllOptionsSelected;

    this.updateSelection({
      filterObject: {
        name: this.dropdownName,
        values: [option.text],
        type: type,
      },
    });
  }

  searchInputChanged($event) {
    // Option 'i' case insensitive
    const regexSearch = new RegExp(this.searchInput.value, 'i');
    this.filteredOptions = this.options.filter((option) => regexSearch.test(option.text));
  }

  removeSelection(option) {
    option.selected = false;

    this.updateSelection({
      filterObject: {
        name: this.dropdownName,
        values: [option.text],
        type: tableau.FilterUpdateType.REMOVE,
      },
    });
  }
}

export default {
  template,
  controller: MultiSelectDropdownController,
  bindings: {
    dropdownName: '<',
    dropdownPrompt: '<',
    options: '<',
    updateSelection: '&',
  },
  controllerAs: 'vm',
};
